import axios from "axios";

import {
    config,
    freeTrial
  } from "../../../utils/constants";
  
  import { isDefined } from "../../../utils/utils";

export function saveFreeTrial(name, email, contact, specialty, organizacao) {

    let language = localStorage.getItem('i18nextLng')
    if (language != null && language !== "") {
        if (language.length > 2) {
            let abrvLang = language.substr(0, 2).toUpperCase();
            if (abrvLang === "PT") {
            language = 'PT'
            } else {
            language = 'EN'
            }
        } else {
            language = 'EN'
        }
    } 
    else {
        language = 'EN'
    }
    var values = {
        name: name,
        email: email,
        contact: contact,
        specialty: specialty,
        description: "",
        address: "",
        district: "",
        country: "",
        photoUri: "",
        language: language,
        organizacao: organizacao
      };

    const url = `${config.url.API_URL}${freeTrial}`;
    
    return dispatch => {
      axios
        .post(url, values)
        .then(resp => {
          dispatch([
            { type: "SUBMIT_FORM_FREETRIAL_SUCESS", payload: resp.data, acvalues: values }
          ]);
        })
        .catch(e => {
          dispatch([
            { type: "SUBMIT_FORM_FREETRIAL_ERROR", payload: e.response, acvalues: values }
          ]);
        });
    };
  }